import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=e2cb37aa&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=e2cb37aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb37aa",
  null
  
)

export default component.exports